import { useMemo } from "react";
import { useCarReservationCard as useCoreCarReservationCard } from "@apac/components/cars";
import type { Reservation } from "@b2bportal/ground-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import { getCarConfirmationCode } from "@/utilities/cars";
import { formatDateWithWeekday } from "@/utilities/formatDate";

export const useCarReservationCard = (reservation: Reservation) => {
  const { t, formatDateTime } = useI18nContext();
  const { text: coreText } = useCoreCarReservationCard(reservation);

  return useMemo(
    () => ({
      text: {
        ...coreText,
        confirmation: getCarConfirmationCode(reservation),
        product: t("core-cars.postbooking.product"),
        pickupDate: formatDateWithWeekday(
          dayjs(reservation.pickUp.dateTime).toDate(),
          formatDateTime
        ),
        dropOffDate: formatDateWithWeekday(
          dayjs(reservation.dropOff.dateTime).toDate(),
          formatDateTime
        ),
      },
    }),
    [coreText, t, reservation, formatDateTime]
  );
};
